import {
	GlobalEmailTemplateMetadata,
	GlobalEmailTemplate,
} from '@models/global-email-templates';

export class SelectBusinessEmailTemplate {
	static readonly type = '[Business Email Templates] Select Template';
	constructor(public templateId: string) {}
}

export class LoadBusinessEmailTemplateVersions {
	static readonly type = '[Business Email Templates] Load Template Version';
	constructor(public templateId: string) {}
}

export class CreateBusinessEmailTemplate {
	static readonly type = '[Business Email Templates] Create Template';
	constructor(
		public template: Omit<GlobalEmailTemplateMetadata, 'id'>,
		public afterCreateAction?: (templateId: string) => void,
	) {}
}

export class UpdateBusinessEmailTemplate {
	static readonly type = '[Business Email Templates] Update Template';
	constructor(
		public templateId: string,
		public templateMetadata: Partial<GlobalEmailTemplateMetadata>,
		public templateVersion: Omit<Partial<GlobalEmailTemplate>, 'id'>,
	) {}
}

export class DeleteBusinessEmailTemplate {
	static readonly type = '[Business Email Templates] Delete Template';
	constructor(public id: string) {}
}
